import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useParams, useHistory } from "react-router";
import moment from "moment";
import {
  Button,
  TextField,
  Typography,
  FormControlLabel,
  FormGroup,
  Switch,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";


import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useGetRoomTypes from "../../queries/roomType/getRoomTypeLinks";

import useRateTypes from "../../queries/roomType/getRateTypes";

import useProperty from "../../queries/property/getProperties";
import useGifts from "../../queries/gift/getGifts";

import useCreateAudit from "../../mutation/audit/createAudit";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  name_chinese: yup.string().required("Name is required"),
  code: yup.string().required("Promo Code is required"),
  startDate: yup.date().required("Start Date is required"),
  endDate: yup.date().required("End Date is required"),
  checkinRangeStart: yup.date().nullable(),
  checkinRangeEnd: yup.date().nullable(),
  checkoutRangeStart: yup.date().nullable(),
  checkoutRangeEnd: yup.date().nullable(),
  redemptionLimit: yup
    .number()
    .integer("Redemption Limit cannot be a decimal value")
    .positive("Redemption Limit cannot be 0 or negative")
    .nullable(true)
    .transform((v, o) => (o === "" ? null : v)),
  periodDiscountMidLeaseHalf: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0"),
  periodDiscountEndLeaseHalf: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0"),
  periodDiscountMidLeaseShort: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0"),
  promotionalPeriodLaundryShort: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  promotionalPeriodLaundryHalf: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  promotionalPeriodLaundryFull: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  weeklyRentRebateLaundryShort: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  weeklyRentRebateLaundryHalf: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  weeklyRentRebateLaundryFull: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  hkRateOverrideAmountFull: yup
    .number()
    .typeError("Monthly Rate Amount must be a number")
    .min(0, "Monthly Rate Amount cannot be less than 0"),
  hkRateOverrideLaundryFull: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  rentFreePromoLaundryShort: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  rentFreePromoLaundryHalf: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  rentFreePromoLaundryFull: yup
    .number()
    .typeError("Laundry Credit must be a number")
    .min(0, "Laundry Credit cannot be less than 0"),
  // promotionalPeriodGift1Short: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // promotionalPeriodGift1Half: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // promotionalPeriodGift1Full: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // weeklyRentRebateGift1Short: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // weeklyRentRebateGift1Half: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // weeklyRentRebateGift1Full: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // rentFreePromoGift1Short: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // rentFreePromoGift1Half: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // rentFreePromoGift1Full: yup
  //   .string()
  //   .typeError("Gift1 must be a string")
  //   .min(0, "Gift1 cannot be less than 0"),
  // promotionalPeriodGift2Short: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // promotionalPeriodGift2Half: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // promotionalPeriodGift2Full: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // weeklyRentRebateGift2Short: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // weeklyRentRebateGift2Half: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // weeklyRentRebateGift2Full: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // rentFreePromoGift2Short: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // rentFreePromoGift2Half: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  // rentFreePromoGift2Full: yup
  //   .string()
  //   .typeError("Gift2 must be a string")
  //   .min(0, "Gift2 cannot be less than 0"),
  depositHalf: yup
    .number()
    .positive("Deposit cannot be 0 or negative")
    .nullable(true)
    .transform((v, o) => (o === "" ? null : v)),
  periodDiscountMidLeaseFull: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0"),
  periodDiscountEndLeaseFull: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0"),
  periodDiscountEndLeaseShort: yup
    .number()
    .typeError("Weekly Rent Rebate must be a number")
    .min(0, "Weekly Rent Rebate cannot be less than 0"),
  depositFull: yup
    .number()
    .positive("Deposit cannot be 0 or negative")
    .nullable(true)
    .transform((v, o) => (o === "" ? null : v)),
  depositShort: yup
    .number()
    .positive("Deposit cannot be 0 or negative")
    .nullable(true)
    .transform((v, o) => (o === "" ? null : v)),
  weeklyRentRebateHalf: yup
    .number()
    .typeError("Weekly Rent Rebate must be a number")
    .min(0, "Weekly Rent Rebate cannot be less than 0"),
  weeklyRentRebateShort: yup
    .number()
    .typeError("Weekly Rent Rebate must be a number")
    .min(0, "Weekly Rent Rebate cannot be less than 0"),
  weeklyRentRebateFull: yup
    .number()
    .typeError("Weekly Rent Rebate must be a number")
    .min(0, "Weekly Rent Rebate cannot be less than 0"),
  type: yup.object().required("A type must be selected."),
  weeksFreeMidleaseShort: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  weeksFreeEndleaseShort: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  weeksFreeMidleaseHalf: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  weeksFreeEndleaseHalf: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  weeksFreeMidleaseFull: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  weeksFreeEndleaseFull: yup
    .number()
    .typeError("No. of weeks free must be an integer")
    .min(0, "No. of weeks free cannot be less than 0"),
  monthsFreeRentShort: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  monthsFreeRentHalf: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  monthsFreeRentFull: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  rentOffPerMonthHkdShort: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  rentOffPerMonthHkdHalf: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  rentOffPerMonthHkdFull: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  utilitiesOffPerMonthHkdShort: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  utilitiesOffPerMonthHkdHalf: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  utilitiesOffPerMonthHkdFull: yup
    .number()
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  daysBeforeLeaseStartShort: yup
    .number()
    .integer("Must be a whole number of days")
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  daysBeforeLeaseStartHalf: yup
    .number()
    .integer("Must be a whole number of days")
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
  daysBeforeLeaseStartFull: yup
    .number()
    .integer("Must be a whole number of days")
    .typeError("Must be a number")
    .min(0, "Cannot be less than 0"),
});

const NewPromotion = (props) => {
  const history = useHistory();

  const [roomTypeResponse, setRoomTypeResponse] = useGetRoomTypes();
  const [tariffResponse, resetTariffResponse] = useRateTypes();

  const [auditResponse, setAuditData] = useCreateAudit();
  const [selectedType, setSelectedType] = useState();
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [checkinRangeStart, setCheckinStartDate] = useState(null);
  const [checkinRangeEnd, setCheckinEndDate] = useState(null);
  const [checkoutRangeStart, setCheckoutStartDate] = useState(null);
  const [checkoutRangeEnd, setCheckoutEndDate] = useState(null);

  const [roomTypeOptions, setRoomTypeOptions] = useState([]);

  const [propertyResponse, resetProperty] = useProperty();

  const [propertyOptions, setPropertyOptions] = useState([]);

  const [giftResponse, resetGifts] = useGifts();
  const [giftOptions, setGiftOptions] = useState([]);
  const [rateOptions, setRateOptions] = useState([]);

  const propertyChange = (value) => {
    setValue("properties", value);
  };

  const promotionOptions = [
    { label: "Promotional Period", value: "promotional_period" },
    { label: "Weekly Rent Rebate", value: "weekly_rent_rebate" },
    { label: "Rent Free Promo", value: "rent_free_promo" },
    { label: "HK Rent Free Promo", value: "hk_prop_promo" },
    { label: "HK Rate Override", value: "hk_rate_override" },
  ];

  const { control, register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
    defaultValue: {
      no_alumni: false,
      set2: false,
    },
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (roomTypeResponse.data) {
      let data = roomTypeResponse.data;
      let roomTypeOptions = [];
      for (var i = 0; i < data.length; i++) {
        let roomType = data[i];
        console.log(roomType);
        roomTypeOptions.push({
          label: roomType.name,
          value: roomType.id,
        });
      }

      setRoomTypeOptions(roomTypeOptions);
    }
  }, [roomTypeResponse]);

  useEffect(() => {
    if (propertyResponse.data) {
      //setup options
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
    }
  }, [propertyResponse]);

  useEffect(() => {
    if (giftResponse.data) {
      //setup gifts
      let giftData = giftResponse.data;
      let giftOptions = [];
      for (var i = 0; i < giftData.length; i++) {
        let gift = giftData[i];
        giftOptions.push({
          label: gift.name,
          value: gift.id,
        });
      }

      setGiftOptions(giftOptions);
    }
  }, [giftResponse]);

  useEffect(() => {
    if (tariffResponse.data) {
      let rateData = tariffResponse.data;
      let rateOptions = [];
      for (var i = 0; i < rateData.length; i++) {
        let rate = rateData[i];
        rateOptions.push({
          label: rate.name,
          value: rate.id,
        });
      }

      setRateOptions(rateOptions);
    }
  }, [tariffResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/promotions";
  };

  const typeChange = (value) => {
    if (value != null) {
      setValue("type", { label: value.label, value: value.value });

      setSelectedType(value.value);
    }
  };

  var countDecimals = function (value) {
    if (Math.floor(value) === value) return 0;
    if (value.toString().split(".").length > 1) {
      return value.toString().split(".")[1].length || 0;
    } else {
      return 0;
    }
  };

  const handleStartDateChange = (value) => {
    setStartDate(value);
    setValue("startDate", value ? value.toDate() : null);
  };
  const handleEndDateChange = (value) => {
    setEndDate(value);
    setValue("endDate", value ? value.toDate() : null);
  };
  const handleCheckinStartDateChange = (value) => {
    setCheckinStartDate(value);
    setValue("checkinRangeStart", value ? value.toDate() : null);
  };
  const handleCheckoutStartDateChange = (value) => {
    setCheckoutStartDate(value);
    setValue("checkoutRangeStart", value ? value.toDate() : null);
  };
  const handleCheckinEndDateChange = (value) => {
    setCheckinEndDate(value);
    setValue("checkinRangeEnd", value ? value.toDate() : null);
  };
  const handleCheckoutEndDateChange = (value) => {
    setCheckoutEndDate(value);
    setValue("checkoutRangeEnd", value ? value.toDate() : null);
  };

  const determineType = (type) => {
    switch (type) {
      case "Short Term":
        return "Short";
        break;
      case "Full Year":
        return "Full";
        break;
      case "Half Year":
        return "Half";
        break;
      default:
        return "";
        break;
    }
  };

  const roomTypeChange = (value) => {
    setValue("room_types", value);
  };

  const onDepositChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    if (countDecimals(value) > 2) {
      setValue("deposit" + typeText, Number(value).toFixed(2));
    }
  };
  const onMidLeaseChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    if (countDecimals(value) > 2) {
      setValue("periodDiscountMidLease" + typeText, Number(value).toFixed(2));
    }
  };
  const onEndLeaseChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    if (countDecimals(value) > 2) {
      setValue("periodDiscountEndLease" + typeText, Number(value).toFixed(2));
    }
  };

  const onWeeklyRebateChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    if (countDecimals(value) > 2) {
      setValue("weeklyRentRebate" + typeText, Number(value).toFixed(2));
    }
  };

  const onLaudryCreditChange = (event, promoType, leaseType) => {
    let typeText = determineType(leaseType);
    let value = event.target.value;
    console.log(countDecimals(value));
    if (countDecimals(value) > 2) {
      setValue(promoType + "Laundry" + typeText, Number(value).toFixed(2));
    }
  };

  const onGift1Change = (event, promoType, leaseType) => {
    let typeText = determineType(leaseType);
    if (event) {
      let value = event.value;
      setValue(promoType + "Gift1" + typeText, value);
    } else {
      setValue(promoType + "Gift1" + typeText, null);
    }
  };

  const onGift2Change = (event, promoType, leaseType) => {
    let typeText = determineType(leaseType);
    if (event) {
      let value = event.value;
      setValue(promoType + "Gift2" + typeText, value);
    } else {
      setValue(promoType + "Gift2" + typeText, null);
    }
  };

  const onRateTypeChange = (event, promoType, leaseType) => {
    let typeText = determineType(leaseType);
    let value = event.value;
    if (value) {
      setValue(promoType + "RateType" + typeText, value);
    } else {
      setValue(promoType + "RateType" + typeText, null);
    }
  };

  const onRentFreeMidLeaseChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    setValue("weeksFreeMidlease" + typeText, Number(value));
  };

  const onRentFreeEndLeaseChange = (event, type) => {
    let typeText = determineType(type);
    let value = event.target.value;
    setValue("weeksFreeEndlease" + typeText, Number(value));
  };

  const onAlumniChange = (event) => {
    console.log(event.target.checked);
    setValue("no_alumni", event.target.checked);
  };

  const onSet2Change = (event) => {
    console.log(event.target.checked);
    setValue("set2", event.target.checked);
  };

  const onSubmit = (values) => {
    //check checkin and checkout range
    if (
      !(values.checkinRangeStart == null && values.checkinRangeEnd == null) &&
      !(values.checkinRangeStart != null && values.checkinRangeEnd != null)
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Check-In Range Values are invalid",
      });
      return;
    }
    if (
      !(values.checkoutRangeStart == null && values.checkoutRangeEnd == null) &&
      !(values.checkoutRangeStart != null && values.checkoutRangeEnd != null)
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Check-Out Range Values are invalid",
      });
      return;
    }

    switch (values.type.value) {
      case "promotional_period":
        let shortObj = {
          tariff_name: "Short Term",
          periodDeposit: values.depositShort,
          periodDiscountMidLease: values.periodDiscountMidLeaseShort,
          periodDiscountEndLease: values.periodDiscountEndLeaseShort,
          laundryCredit: values.promotionalPeriodLaundryShort,
          gift1: values.promotionalPeriodGift1Short,
          gift2: values.promotionalPeriodGift2Short,
        };
        let halfObj = {
          tariff_name: "Half Year",
          periodDeposit: values.depositHalf,
          periodDiscountMidLease: values.periodDiscountMidLeaseHalf,
          periodDiscountEndLease: values.periodDiscountEndLeaseHalf,
          laundryCredit: values.promotionalPeriodLaundryHalf,
          gift1: values.promotionalPeriodGift1Half,
          gift2: values.promotionalPeriodGift2Half,
        };
        let fullObj = {
          tariff_name: "Full Year",
          periodDeposit: values.depositFull,
          periodDiscountMidLease: values.periodDiscountMidLeaseFull,
          periodDiscountEndLease: values.periodDiscountEndLeaseFull,
          laundryCredit: values.promotionalPeriodLaundryFull,
          gift1: values.promotionalPeriodGift1Full,
          gift2: values.promotionalPeriodGift2Full,
        };
        values.promotionalPeriod = [shortObj, halfObj, fullObj];
        break;
      case "weekly_rent_rebate":
        let shortWeekObj = {
          tariff_name: "Short Term",
          deposit: values.depositShort,
          weeklyRebateAmount: values.weeklyRentRebateShort,
          laundryCredit: values.weeklyRentRebateLaundryShort,
          gift1: values.weeklyRentRebateGift1Short,
          gift2: values.weeklyRentRebateGift2Short,
          rate_type: values.weeklyRentRebateRateTypeShort,
        };
        let halfWeekObj = {
          tariff_name: "Half Year",
          deposit: values.depositHalf,
          weeklyRebateAmount: values.weeklyRentRebateHalf,
          laundryCredit: values.weeklyRentRebateLaundryHalf,
          gift1: values.weeklyRentRebateGift1Half,
          gift2: values.weeklyRentRebateGift2Half,
          rate_type: values.weeklyRentRebateRateTypeHalf,
        };
        let fullWeekObj = {
          tariff_name: "Full Year",
          deposit: values.depositFull,
          weeklyRebateAmount: values.weeklyRentRebateFull,
          laundryCredit: values.weeklyRentRebateLaundryFull,
          gift1: values.weeklyRentRebateGift1Full,
          gift2: values.weeklyRentRebateGift2Full,
          rate_type: values.weeklyRentRebateRateTypeFull,
        };
        values.weeklyRentRebate = [shortWeekObj, halfWeekObj, fullWeekObj];
        break;
      case "rent_free_promo":
        let rentFreeShortWeekObj = {
          tariff_name: "Short Term",
          weeksFreeMidlease: values.weeksFreeMidleaseShort,
          weeksFreeEndlease: values.weeksFreeEndleaseShort,
          laundryCredit: values.rentFreePromoLaundryShort,
          gift1: values.rentFreePromoGift1Short,
          gift2: values.rentFreePromoGift2Short,
        };
        let rentFreeHalfWeekObj = {
          tariff_name: "Half Year",
          weeksFreeMidlease: values.weeksFreeMidleaseHalf,
          weeksFreeEndlease: values.weeksFreeEndleaseHalf,
          laundryCredit: values.rentFreePromoLaundryHalf,
          gift1: values.rentFreePromoGift1Half,
          gift2: values.rentFreePromoGift2Half,
        };
        let rentFreeFullWeekObj = {
          tariff_name: "Full Year",
          deposit: values.depositFull,
          weeksFreeMidlease: values.weeksFreeMidleaseFull,
          weeksFreeEndlease: values.weeksFreeEndleaseFull,
          laundryCredit: values.rentFreePromoLaundryFull,
          gift1: values.rentFreePromoGift1Full,
          gift2: values.rentFreePromoGift2Full,
        };
        values.rentFreePromo = [
          rentFreeShortWeekObj,
          rentFreeHalfWeekObj,
          rentFreeFullWeekObj,
        ];
        break;
      case "hk_prop_promo": {
        let hkShort = {
          tariff_name: "Short Term",
          monthsFreeRent: values.monthsFreeRentShort,
          rentOffPerMonthHkd: values.rentOffPerMonthHkdShort,
          utilitiesOffPerMonthHkd: values.utilitiesOffPerMonthHkdShort,
          daysBeforeLeaseStartForCreditNote:
            values.daysBeforeLeaseStartShort,
          gift1: values.hkPropPromoGift1Short,
          gift2: values.hkPropPromoGift2Short,
        };
        let hkHalf = {
          tariff_name: "Half Year",
          monthsFreeRent: values.monthsFreeRentHalf,
          rentOffPerMonthHkd: values.rentOffPerMonthHkdHalf,
          utilitiesOffPerMonthHkd: values.utilitiesOffPerMonthHkdHalf,
          daysBeforeLeaseStartForCreditNote: values.daysBeforeLeaseStartHalf,
          gift1: values.hkPropPromoGift1Half,
          gift2: values.hkPropPromoGift2Half,
        };
        let hkFull = {
          tariff_name: "Full Year",
          monthsFreeRent: values.monthsFreeRentFull,
          rentOffPerMonthHkd: values.rentOffPerMonthHkdFull,
          utilitiesOffPerMonthHkd: values.utilitiesOffPerMonthHkdFull,
          daysBeforeLeaseStartForCreditNote: values.daysBeforeLeaseStartFull,
          gift1: values.hkPropPromoGift1Full,
          gift2: values.hkPropPromoGift2Full,
        };
        values.hkPropPromo = [hkShort, hkHalf, hkFull];
        break;
      }
      case "hk_rate_override": {
        values.hkRateOverride = [
          {
            tariff_name: "Full Year",
            rateAmount: values.hkRateOverrideAmountFull,
            laundryCredit: values.hkRateOverrideLaundryFull,
            gift1: values.hkRateOverrideGift1Full,
            gift2: values.hkRateOverrideGift2Full,
          },
        ];
        break;
      }
      default:
        break;
    }
    let roomTypes = [];
    if (values.room_types) {
      for (var i = 0; i < values.room_types.length; i++) {
        roomTypes.push(values.room_types[i].value);
      }
      values.room_types = roomTypes;
    }
    values.active = true;
    values.endDate = moment(values.endDate).endOf("day");
    delete values.depositShort;
    delete values.depositHalf;
    delete values.depositFull;
    if (values.type.value == "promotional_period") {
      delete values.periodDiscountMidLeaseShort;
      delete values.periodDiscountEndLeaseShort;
      delete values.periodDiscountMidLeaseHalf;
      delete values.periodDiscountEndLeaseHalf;
      delete values.periodDiscountMidLeaseFull;
      delete values.periodDiscountEndLeaseFull;
      delete values.depositHalf;
      delete values.depositFull;
      delete values.promotionalPeriodLaundryShort;
      delete values.promotionalPeriodLaundryHalf;
      delete values.promotionalPeriodLaundryFull;
      delete values.promotionalPeriodGift1Short;
      delete values.promotionalPeriodGift1Half;
      delete values.promotionalPeriodGift1Full;
      delete values.promotionalPeriodGift2Short;
      delete values.promotionalPeriodGift2Half;
      delete values.promotionalPeriodGift2Full;
    }
    if (values.type.value == "weekly_rent_rebate") {
      delete values.weeklyRentRebateShort;
      delete values.weeklyRentRebateHalf;
      delete values.weeklyRentRebateFull;
      delete values.depositHalf;
      delete values.depositFull;
      delete values.weeklyRentRebateLaundryShort;
      delete values.weeklyRentRebateLaundryHalf;
      delete values.weeklyRentRebateLaundryFull;
      delete values.weeklyRentRebateGift1Short;
      delete values.weeklyRentRebateGift1Half;
      delete values.weeklyRentRebateGift1Full;
      delete values.weeklyRentRebateGift2Short;
      delete values.weeklyRentRebateGift2Half;
      delete values.weeklyRentRebateGift2Full;
      delete values.weeklyRentRebateRateTypeShort;
      delete values.weeklyRentRebateRateTypeHalf;
      delete values.weeklyRentRebateRateTypeFull;
    }
    if (values.type.value == "rent_free_promo") {
      delete values.weeksFreeMidleaseShort;
      delete values.weeksFreeMidleaseHalf;
      delete values.weeksFreeMidleaseFull;
      delete values.weeksFreeEndleaseShort;
      delete values.weeksFreeEndleaseHalf;
      delete values.weeksFreeEndleaseFull;
      delete values.rentFreePromoLaundryShort;
      delete values.rentFreePromoLaundryHalf;
      delete values.rentFreePromoLaundryFull;
      delete values.rentFreePromoGift1Short;
      delete values.rentFreePromoGift1Half;
      delete values.rentFreePromoGift1Full;
      delete values.rentFreePromoGift2Short;
      delete values.rentFreePromoGift2Half;
      delete values.rentFreePromoGift2Full;
    }
    if (values.type.value == "hk_prop_promo") {
      delete values.monthsFreeRentShort;
      delete values.monthsFreeRentHalf;
      delete values.monthsFreeRentFull;
      delete values.rentOffPerMonthHkdShort;
      delete values.rentOffPerMonthHkdHalf;
      delete values.rentOffPerMonthHkdFull;
      delete values.utilitiesOffPerMonthHkdShort;
      delete values.utilitiesOffPerMonthHkdHalf;
      delete values.utilitiesOffPerMonthHkdFull;
      delete values.daysBeforeLeaseStartShort;
      delete values.daysBeforeLeaseStartHalf;
      delete values.daysBeforeLeaseStartFull;
      delete values.hkPropPromoGift1Short;
      delete values.hkPropPromoGift1Half;
      delete values.hkPropPromoGift1Full;
      delete values.hkPropPromoGift2Short;
      delete values.hkPropPromoGift2Half;
      delete values.hkPropPromoGift2Full;
    }
    if (values.type.value == "hk_rate_override") {
      delete values.hkRateOverrideAmountFull;
      delete values.hkRateOverrideLaundryFull;
      delete values.hkRateOverrideGift1Full;
      delete values.hkRateOverrideGift2Full;
    }
    values.type = values.type.value;

    let properties = [];
    if (values.properties) {
      for (var i = 0; i < values.properties.length; i++) {
        properties.push(values.properties[i].value);
      }
    }
    values.properties = properties;
    if (values.gift1) {
      values.gift1 = values.gift1.value;
    }

    if (values.gift2) {
      values.gift2 = values.gift2.value;
    }

    // if (!values.laundryCredit || values.laundryCredit == NaN) {
    //   values.laundryCredit = 0;
    // }

    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
      <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          type: "promotion",
          action: "create",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });

    //setData(values);
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Promotion Audit created",
        });
        history.push("/dashboard/promotions");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Promo Code Used") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "The Promo Code has already been used for an existing Promotion for the selected period. Please use another Promo Code.",
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const renderContent = () => {
    return (
      <FormPageShell>
        <form
         
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <Stack spacing={2}>
            <FormPageCard>
                <FormPageHeader
                  title="New Promotion"
                  onBack={goBack}
                  subtitle="Please fill in the required fields."
                />
                <TextField
                  name="name"
                  margin="normal"
                  fullWidth
                  label="Name*"
                  variant="outlined"
                  inputRef={register}
                  error={errors.name != null}
                  helperText={errors.name != null ? errors.name.message : null}
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="name_chinese"
                  margin="normal"
                  fullWidth
                  label="Name (Chinese)*"
                  variant="outlined"
                  inputRef={register}
                  error={errors.name_chinese != null}
                  helperText={
                    errors.name_chinese != null
                      ? errors.name_chinese.message
                      : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="code"
                  margin="normal"
                  fullWidth
                  label="Promo Code*"
                  variant="outlined"
                  inputRef={register}
                  error={errors.code != null}
                  helperText={errors.code != null ? errors.code.message : null}
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="description"
                  margin="normal"
                  fullWidth
                  multiline={true}
                  label="Description"
                  variant="outlined"
                  inputRef={register}
                  error={errors.description != null}
                  helperText={
                    errors.description != null
                      ? errors.description.message
                      : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="description_chinese"
                  margin="normal"
                  fullWidth
                  multiline={true}
                  label="Description (Chinese)"
                  variant="outlined"
                  inputRef={register}
                  error={errors.description_chinese != null}
                  helperText={
                    errors.description_chinese != null
                      ? errors.description_chinese.message
                      : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="context"
                  margin="normal"
                  fullWidth
                  multiline={true}
                  label="Context (Provide a short description on Price Breakdown)"
                  variant="outlined"
                  inputRef={register}
                  error={errors.context != null}
                  helperText={
                    errors.context != null ? errors.context.message : null
                  }
                  disabled={auditResponse.loading}
                />
                <TextField
                  name="context_chinese"
                  margin="normal"
                  fullWidth
                  multiline={true}
                  label="Context (Chinese)"
                  variant="outlined"
                  inputRef={register}
                  error={errors.context_chinese != null}
                  helperText={
                    errors.context_chinese != null
                      ? errors.context_chinese.message
                      : null
                  }
                  disabled={auditResponse.loading}
                />
<Controller
                    name="startDate"
                    control={control}
                    defaultValue={startDate}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="Start Date*"
                          value={startDate}
                          onChange={handleStartDateChange}
                          format="DD/MM/YYYY"
                          maxDate={endDate}
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.startDate != null,
                              helperText: errors.startDate != null
                              ? errors.startDate.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
                  <Controller
                    name="endDate"
                    control={control}
                    defaultValue={endDate}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="End Date*"
                          value={endDate}
                          onChange={handleEndDateChange}
                          format="DD/MM/YYYY"
                          minDate={startDate}
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.endDate != null,
                              helperText: errors.endDate != null
                              ? errors.endDate.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
                  <Controller
                    name="checkinRangeStart"
                    control={control}
                    defaultValue={checkinRangeStart}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="Check-In Range Start Date*"
                          value={checkinRangeStart}
                          onChange={handleCheckinStartDateChange}
                          format="DD/MM/YYYY"
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.checkinRangeStart != null,
                              helperText: errors.checkinRangeStart != null
                              ? errors.checkinRangeStart.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
                  <Controller
                    name="checkinRangeEnd"
                    control={control}
                    defaultValue={checkinRangeEnd}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="Check-In Range End Date*"
                          value={checkinRangeEnd}
                          onChange={handleCheckinEndDateChange}
                          format="DD/MM/YYYY"
                          minDate={checkinRangeStart || undefined}
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.checkinRangeEnd != null,
                              helperText: errors.checkinRangeEnd != null
                              ? errors.checkinRangeEnd.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
                  <Controller
                    name="checkoutRangeStart"
                    control={control}
                    defaultValue={checkoutRangeStart}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="Check-Out Range Start Date*"
                          value={checkoutRangeStart}
                          onChange={handleCheckoutStartDateChange}
                          format="DD/MM/YYYY"
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.checkoutRangeStart != null,
                              helperText: errors.checkoutRangeStart != null
                              ? errors.checkoutRangeStart.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
                  <Controller
                    name="checkoutRangeEnd"
                    control={control}
                    defaultValue={checkoutRangeEnd}
                    render={({ ...props }) => {
                      return (
                        <DatePicker
                          label="Check-Out Range End Date*"
                          value={checkoutRangeEnd}
                          onChange={handleCheckoutEndDateChange}
                          format="DD/MM/YYYY"
                          minDate={checkoutRangeStart || undefined}
                          disabled={auditResponse.loading}
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                              margin: "normal",
                              error: errors.checkoutRangeEnd != null,
                              helperText: errors.checkoutRangeEnd != null
                              ? errors.checkoutRangeEnd.message
                              : null,
                            },
                          }}
                        />
                      );
                    }}
                  />
<TextField
                  name="redemptionLimit"
                  margin="normal"
                  fullWidth
                  label="Redemption Limit (Leave empty to not set a limit)"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.redemptionLimit != null}
                  helperText={
                    errors.redemptionLimit != null
                      ? errors.redemptionLimit.message
                      : null
                  }
                  disabled={auditResponse.loading}
                />
                <Controller
                  name={"no_alumni"}
                  control={control}
                  render={() => {
                    return (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              name={"no_alumni"}
                              onChange={onAlumniChange}
                            />
                          }
                          label="No Alumni (Prevent pre-exisiting tenants from using this promotion)"
                        />
                      </FormGroup>
                    );
                  }}
                />
                <Controller
                  name={"set2"}
                  control={control}
                  render={() => {
                    return (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              name={"set2"}
                              onChange={onSet2Change}
                            />
                          }
                          label="Set2 Promotion (Use this promotion when Set2 rates are applied)"
                        />
                      </FormGroup>
                    );
                  }}
                />
                {propertyOptions.length > 0 && (
                  <div>
                    <p style={{ fontSize: 16, fontWeight: "bold" }}>Property</p>
                    <div>
                      <Controller
                        name="properties"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <CreatableSelect
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.room_types
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isMulti
                              options={propertyOptions}
                              onChange={propertyChange}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.properties && (
                        <div>{errors.properties.message}</div>
                      )}
                    </div>
                  </div>
                )}
                <p style={{ fontSize: 16, fontWeight: "bold" }}>
                  Room Type Specific (Leave empty if not room specific)
                </p>
                {(roomTypeOptions.length > 0 || !roomTypeResponse.loading) && (
                  <div>
                    <Controller
                      name="room_types"
                      control={control}
                      render={({ ...props }) => {
                        return (
                          <CreatableSelect
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                borderColor: errors.room_types
                                  ? "red"
                                  : provided.borderColor,
                              }),
                            }}
                            isMulti
                            options={roomTypeOptions}
                            onChange={roomTypeChange}
                            disabled={auditResponse.loading}
                          />
                        );
                      }}
                    />
                    {errors.room_types && (
                      <div>{errors.room_types.message}</div>
                    )}
                  </div>
                )}
                <p style={{ fontSize: 16, fontWeight: "bold" }}>Promotion Type</p>
                <div>
                  <Controller
                    name="type"
                    control={control}
                    render={({ ...props }) => {
                      return (
                        <Select
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.type
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          options={promotionOptions}
                          onChange={typeChange}
                          disabled={auditResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.type && (
                    <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                      {errors.type.message}
                    </div>
                  )}
                </div>
              </FormPageCard>
            {selectedType && selectedType == "promotional_period" && (
              <FormPageCard>
                  <Typography component="h4" variant="h5">
                    Promotional Period
                  </Typography>
                  <p>
                    Promotional Period codes are automatically applied during
                    the Promotion Period (Users can opt to remove it if they
                    wish to). There are two parts to a Promotional Period Code:
                  </p>
                  <ul>
                    <li>
                      A new Deposit amount (replaces Addon Prices as well)
                    </li>
                    <li>
                      A flat discount applied to the reservation, applied
                      separately at the middle and end of the Reservation's
                      lease period.
                    </li>
                  </ul>
                  <p>
                    Note that the discount amount applied to the end of the
                    lease period is applied on the Monday closest to the last
                    28th day of the Reservation.
                  </p>
                  <Typography component="h4" variant="sub">
                    Short Term Lease
                  </Typography>
                  <TextField
                    name="depositShort"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Short Term");
                    }}
                    error={errors.depositShort != null}
                    helperText={
                      errors.depositShort != null
                        ? errors.depositShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountMidLeaseShort"
                    margin="normal"
                    fullWidth
                    label="Mid Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onMidLeaseChange(value, "Short Term");
                    }}
                    error={errors.periodDiscountMidLeaseShort != null}
                    helperText={
                      errors.periodDiscountMidLeaseShort != null
                        ? errors.periodDiscountMidLeaseShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountEndLeaseShort"
                    margin="normal"
                    fullWidth
                    label="End Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onEndLeaseChange(value, "Short Term");
                    }}
                    error={errors.periodDiscountEndLeaseShort != null}
                    helperText={
                      errors.periodDiscountEndLeaseShort != null
                        ? errors.periodDiscountEndLeaseShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="promotionalPeriodLaundryShort"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "promotionalPeriod",
                        "Short Term"
                      );
                    }}
                    error={errors.promotionalPeriodLaundryShort != null}
                    helperText={
                      errors.promotionalPeriodLaundryShort != null
                        ? errors.promotionalPeriodLaundryShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift1Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "promotionalPeriod",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift1Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift1Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift2Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "promotionalPeriod",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift2Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift2Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Half Year Lease
                  </Typography>
                  <TextField
                    name="depositHalf"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Half Year");
                    }}
                    error={errors.depositHalf != null}
                    helperText={
                      errors.depositHalf != null
                        ? errors.depositHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountMidLeaseHalf"
                    margin="normal"
                    fullWidth
                    label="Mid Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onMidLeaseChange(value, "Half Year");
                    }}
                    error={errors.periodDiscountMidLeaseHalf != null}
                    helperText={
                      errors.periodDiscountMidLeaseHalf != null
                        ? errors.periodDiscountMidLeaseHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountEndLeaseHalf"
                    margin="normal"
                    fullWidth
                    label="End Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onEndLeaseChange(value, "Half Year");
                    }}
                    error={errors.periodDiscountEndLeaseHalf != null}
                    helperText={
                      errors.periodDiscountEndLeaseHalf != null
                        ? errors.periodDiscountEndLeaseHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="promotionalPeriodLaundryHalf"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "promotionalPeriod",
                        "Half Year"
                      );
                    }}
                    error={errors.promotionalPeriodLaundryHalf != null}
                    helperText={
                      errors.promotionalPeriodLaundryHalf != null
                        ? errors.promotionalPeriodLaundryHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift1Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "promotionalPeriod",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift1Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift1Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift2Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "promotionalPeriod",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift2Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift2Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Full Year Lease
                  </Typography>
                  <TextField
                    name="depositFull"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Full Year");
                    }}
                    error={errors.depositFull != null}
                    helperText={
                      errors.depositFull != null
                        ? errors.depositFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountMidLeaseFull"
                    margin="normal"
                    fullWidth
                    label="Mid Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onMidLeaseChange(value, "Full Year");
                    }}
                    error={errors.periodDiscountMidLeaseFull != null}
                    helperText={
                      errors.periodDiscountMidLeaseFull != null
                        ? errors.periodDiscountMidLeaseFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="periodDiscountEndLeaseFull"
                    margin="normal"
                    fullWidth
                    label="End Lease Discount in AUD"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onEndLeaseChange(value, "Full Year");
                    }}
                    error={errors.periodDiscountEndLeaseFull != null}
                    helperText={
                      errors.periodDiscountEndLeaseFull != null
                        ? errors.periodDiscountEndLeaseFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="promotionalPeriodLaundryFull"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "promotionalPeriod",
                        "Full Year"
                      );
                    }}
                    error={errors.promotionalPeriodLaundryFull != null}
                    helperText={
                      errors.promotionalPeriodLaundryFull != null
                        ? errors.promotionalPeriodLaundryFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift1Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "promotionalPeriod",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="promotionalPeriodGift2Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "promotionalPeriod",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.promotionalPeriodGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.promotionalPeriodGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                </FormPageCard>
            )}
            {selectedType && selectedType == "weekly_rent_rebate" && (
              <FormPageCard>
                  <Typography component="h4" variant="h5">
                    Weekly Rent Rebate
                  </Typography>
                  <p>
                    Weekly Rent Rebate applies Credit Note weekly every Monday
                    during the Guest's stay. There are two parts to a Weekly
                    Rent Rebate Code:
                  </p>
                  <ul>
                    <li>
                      A new Deposit amount (replaces Addon Prices as well)
                    </li>
                    <li>
                      A flat discount amount applied at every week of stay.
                    </li>
                  </ul>
                  <p>
                    Note that the first and last week of stay will be prorated
                    if it is less than 7 days.
                  </p>
                  <Typography component="h4" variant="sub">
                    Short Term Lease
                  </Typography>
                  {/* <TextField
                    name="depositShort"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Short Term");
                    }}
                    error={errors.depositHalf != null}
                    helperText={
                      errors.depositHalf != null
                        ? errors.depositHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeklyRentRebateShort"
                    margin="normal"
                    fullWidth
                    label="Weekly Rent Rebate in AUD (Set 0 to not set it for Short Term Lease)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onWeeklyRebateChange(value, "Short Term");
                    }}
                    error={errors.weeklyRentRebateHalf != null}
                    helperText={
                      errors.weeklyRentRebateHalf != null
                        ? errors.weeklyRentRebateHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  /> */}
                  <TextField
                    name="weeklyRentRebateLaundryShort"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "weeklyRentRebate",
                        "Short Term"
                      );
                    }}
                    error={errors.weeklyRentRebateLaundryShort != null}
                    helperText={
                      errors.weeklyRentRebateLaundryShort != null
                        ? errors.weeklyRentRebateLaundryShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift1Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift1Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift1Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift2Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift1Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift1Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Rate Type (from RMS)</p>
                  {rateOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateRateTypeShort"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={rateOptions}
                              onChange={(value) => {
                                onRateTypeChange(
                                  value,
                                  "weeklyRentRebate",
                                  "Short Term"
                                );
                              }}
                              isDisabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateRateTypeShort && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateRateTypeShort.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Half Year Lease
                  </Typography>
                  {/* <TextField
                    name="depositHalf"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Half Year");
                    }}
                    error={errors.depositHalf != null}
                    helperText={
                      errors.depositHalf != null
                        ? errors.depositHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeklyRentRebateHalf"
                    margin="normal"
                    fullWidth
                    label="Weekly Rent Rebate in AUD (Set 0 to not set it for Half Year Lease)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onWeeklyRebateChange(value, "Half Year");
                    }}
                    error={errors.weeklyRentRebateHalf != null}
                    helperText={
                      errors.weeklyRentRebateHalf != null
                        ? errors.weeklyRentRebateHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  /> */}
                  <TextField
                    name="weeklyRentRebateLaundryHalf"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "weeklyRentRebate",
                        "Half Year"
                      );
                    }}
                    error={errors.weeklyRentRebateLaundryHalf != null}
                    helperText={
                      errors.weeklyRentRebateLaundryHalf != null
                        ? errors.weeklyRentRebateLaundryHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift1Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift1Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift1Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift2Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift2Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift2Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Rate Type (from RMS)</p>
                  {rateOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateRateTypeHalf"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={rateOptions}
                              onChange={(value) => {
                                onRateTypeChange(
                                  value,
                                  "weeklyRentRebate",
                                  "Half Year"
                                );
                              }}
                              isDisabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateRateTypeHalf && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateRateTypeHalf.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Full Year Lease
                  </Typography>
                  {/* <TextField
                    name="depositFull"
                    margin="normal"
                    fullWidth
                    label="Deposit Amount in AUD (Leave empty to not set a deposit amount)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    onChange={(value) => {
                      onDepositChange(value, "Full Year");
                    }}
                    error={errors.depositFull != null}
                    helperText={
                      errors.depositFull != null
                        ? errors.depositFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeklyRentRebateFull"
                    margin="normal"
                    fullWidth
                    label="Weekly Rent Rebate in AUD (Set 0 to not set it for Full Year Lease)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onWeeklyRebateChange(value, "Full Year");
                    }}
                    error={errors.weeklyRentRebateFull != null}
                    helperText={
                      errors.weeklyRentRebateFull != null
                        ? errors.weeklyRentRebateFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  /> */}
                  <TextField
                    name="weeklyRentRebateLaundryFull"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "weeklyRentRebate",
                        "Full Year"
                      );
                    }}
                    error={errors.weeklyRentRebateLaundryFull != null}
                    helperText={
                      errors.weeklyRentRebateLaundryFull != null
                        ? errors.weeklyRentRebateLaundryFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift1Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateGift2Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "weeklyRentRebate",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateGift2Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateGift2Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Rate Type (from RMS)</p>
                  {rateOptions.length > 0 && (
                    <div>
                      <Controller
                        name="weeklyRentRebateRateTypeFull"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={rateOptions}
                              onChange={(value) => {
                                onRateTypeChange(
                                  value,
                                  "weeklyRentRebate",
                                  "Full Year"
                                );
                              }}
                              isDisabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.weeklyRentRebateRateTypeFull && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.weeklyRentRebateRateTypeFull.message}
                        </div>
                      )}
                    </div>
                  )}
                </FormPageCard>
            )}
            {selectedType && selectedType == "rent_free_promo" && (
              <FormPageCard>
                  <Typography component="h4" variant="h5">
                    Rent Free Promo
                  </Typography>
                  <p>
                    When the Promo Code is applied, a user will receive free
                    rent in the form of credit note for a set number of weeks on
                    two instances, the middle of the reservation lease date and
                    the last billing lease date.
                  </p>
                  <Typography component="h4" variant="sub">
                    Short Term Lease
                  </Typography>
                  <TextField
                    name="weeksFreeMidleaseShort"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - Mid Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeMidLeaseChange(value, "Short Term");
                    }}
                    error={errors.weeksFreeMidleaseShort != null}
                    helperText={
                      errors.weeksFreeMidleaseShort != null
                        ? errors.weeksFreeMidleaseShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeksFreeEndleaseShort"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - End Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeEndLeaseChange(value, "Short Term");
                    }}
                    error={errors.weeksFreeEndleaseShort != null}
                    helperText={
                      errors.weeksFreeEndleaseShort != null
                        ? errors.weeksFreeEndleaseShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentFreePromoLaundryShort"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "rentFreePromo",
                        "Short Term"
                      );
                    }}
                    error={errors.rentFreePromoLaundryShort != null}
                    helperText={
                      errors.rentFreePromoLaundryShort != null
                        ? errors.rentFreePromoLaundryShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift1Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "rentFreePromo",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift1Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift1Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift2Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "rentFreePromo",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift2Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift2Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Half Year Lease
                  </Typography>
                  <TextField
                    name="weeksFreeMidleaseHalf"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - Mid Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeMidLeaseChange(value, "Half Year");
                    }}
                    error={errors.weeksFreeMidleaseHalf != null}
                    helperText={
                      errors.weeksFreeMidleaseHalf != null
                        ? errors.weeksFreeMidleaseHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeksFreeEndleaseHalf"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - End Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeEndLeaseChange(value, "Half Year");
                    }}
                    error={errors.weeksFreeEndleaseHalf != null}
                    helperText={
                      errors.weeksFreeEndleaseHalf != null
                        ? errors.weeksFreeEndleaseHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentFreePromoLaundryHalf"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(value, "rentFreePromo", "Half Year");
                    }}
                    error={errors.rentFreePromoLaundryHalf != null}
                    helperText={
                      errors.rentFreePromoLaundryHalf != null
                        ? errors.rentFreePromoLaundryHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift1Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "rentFreePromo",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift1Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift1Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift2Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "rentFreePromo",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift2Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift2Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Full Year Lease
                  </Typography>
                  <TextField
                    name="weeksFreeMidleaseFull"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - Mid Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeMidLeaseChange(value, "Full Year");
                    }}
                    error={errors.weeksFreeMidleaseFull != null}
                    helperText={
                      errors.weeksFreeMidleaseFull != null
                        ? errors.weeksFreeMidleaseFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="weeksFreeEndleaseFull"
                    margin="normal"
                    fullWidth
                    label="No. of Weeks Free - End Lease"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onRentFreeEndLeaseChange(value, "Full Year");
                    }}
                    error={errors.weeksFreeEndleaseFull != null}
                    helperText={
                      errors.weeksFreeEndleaseFull != null
                        ? errors.weeksFreeEndleaseFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentFreePromoLaundryFull"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(value, "rentFreePromo", "Full Year");
                    }}
                    error={errors.rentFreePromoLaundryFull != null}
                    helperText={
                      errors.rentFreePromoLaundryFull != null
                        ? errors.rentFreePromoLaundryFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift1Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "rentFreePromo",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="rentFreePromoGift2Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "rentFreePromo",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.rentFreePromoGift2Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.rentFreePromoGift2Full.message}
                        </div>
                      )}
                    </div>
                  )}
                </FormPageCard>
            )}
            {selectedType && selectedType == "hk_prop_promo" && (
              <FormPageCard>
                  <Typography component="h4" variant="h5">
                    HK Rent Free Promo
                  </Typography>
                  <p>
                    One credit note before lease start. Amount is based on free
                    months (room monthly rent), fixed HKD off rent per lease
                    month, and fixed HKD off utilities per lease month. Trigger
                    date is N days before lease start. If N is 0, the credit note
                    is created when the reservation status is confirmed.
                  </p>
                  <Typography component="h4" variant="sub">
                    Short Term Lease
                  </Typography>
                  <TextField
                    name="monthsFreeRentShort"
                    margin="normal"
                    fullWidth
                    label="Months free rent"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.monthsFreeRentShort != null}
                    helperText={
                      errors.monthsFreeRentShort != null
                        ? errors.monthsFreeRentShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentOffPerMonthHkdShort"
                    margin="normal"
                    fullWidth
                    label="HKD off rent per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.rentOffPerMonthHkdShort != null}
                    helperText={
                      errors.rentOffPerMonthHkdShort != null
                        ? errors.rentOffPerMonthHkdShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="utilitiesOffPerMonthHkdShort"
                    margin="normal"
                    fullWidth
                    label="HKD off utilities fee per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.utilitiesOffPerMonthHkdShort != null}
                    helperText={
                      errors.utilitiesOffPerMonthHkdShort != null
                        ? errors.utilitiesOffPerMonthHkdShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="daysBeforeLeaseStartShort"
                    margin="normal"
                    fullWidth
                    label="Days before lease start to create the credit note"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.daysBeforeLeaseStartShort != null}
                    helperText={
                      errors.daysBeforeLeaseStartShort != null
                        ? errors.daysBeforeLeaseStartShort.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift1Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "hkPropPromo",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift1Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift1Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift2Short"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "hkPropPromo",
                                  "Short Term"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift2Short && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift2Short.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Half Year Lease
                  </Typography>
                  <TextField
                    name="monthsFreeRentHalf"
                    margin="normal"
                    fullWidth
                    label="Months free rent"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.monthsFreeRentHalf != null}
                    helperText={
                      errors.monthsFreeRentHalf != null
                        ? errors.monthsFreeRentHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentOffPerMonthHkdHalf"
                    margin="normal"
                    fullWidth
                    label="HKD off rent per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.rentOffPerMonthHkdHalf != null}
                    helperText={
                      errors.rentOffPerMonthHkdHalf != null
                        ? errors.rentOffPerMonthHkdHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="utilitiesOffPerMonthHkdHalf"
                    margin="normal"
                    fullWidth
                    label="HKD off utilities fee per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.utilitiesOffPerMonthHkdHalf != null}
                    helperText={
                      errors.utilitiesOffPerMonthHkdHalf != null
                        ? errors.utilitiesOffPerMonthHkdHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="daysBeforeLeaseStartHalf"
                    margin="normal"
                    fullWidth
                    label="Days before lease start to create the credit note"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.daysBeforeLeaseStartHalf != null}
                    helperText={
                      errors.daysBeforeLeaseStartHalf != null
                        ? errors.daysBeforeLeaseStartHalf.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift1Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "hkPropPromo",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift1Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift1Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift2Half"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "hkPropPromo",
                                  "Half Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift2Half && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift2Half.message}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <Typography component="h4" variant="sub">
                    Full Year Lease
                  </Typography>
                  <TextField
                    name="monthsFreeRentFull"
                    margin="normal"
                    fullWidth
                    label="Months free rent"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.monthsFreeRentFull != null}
                    helperText={
                      errors.monthsFreeRentFull != null
                        ? errors.monthsFreeRentFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="rentOffPerMonthHkdFull"
                    margin="normal"
                    fullWidth
                    label="HKD off rent per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.rentOffPerMonthHkdFull != null}
                    helperText={
                      errors.rentOffPerMonthHkdFull != null
                        ? errors.rentOffPerMonthHkdFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="utilitiesOffPerMonthHkdFull"
                    margin="normal"
                    fullWidth
                    label="HKD off utilities fee per month"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.utilitiesOffPerMonthHkdFull != null}
                    helperText={
                      errors.utilitiesOffPerMonthHkdFull != null
                        ? errors.utilitiesOffPerMonthHkdFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="daysBeforeLeaseStartFull"
                    margin="normal"
                    fullWidth
                    label="Days before lease start to create the credit note"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.daysBeforeLeaseStartFull != null}
                    helperText={
                      errors.daysBeforeLeaseStartFull != null
                        ? errors.daysBeforeLeaseStartFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift1Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "hkPropPromo",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkPropPromoGift2Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "hkPropPromo",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkPropPromoGift2Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkPropPromoGift2Full.message}
                        </div>
                      )}
                    </div>
                  )}
                </FormPageCard>
            )}
            {selectedType && selectedType == "hk_rate_override" && (
              <FormPageCard>
                  <Typography component="h4" variant="h5">
                    HK Rate Override
                  </Typography>
                  <p>
                    Same as Weekly Rent Rebate for HK properties, but you enter
                    the monthly rate amount in HKD directly instead of selecting
                    an RMS rate type. Currently applies to Full Year lease only.
                  </p>
                  <Typography component="h4" variant="sub">
                    Full Year Lease
                  </Typography>
                  <TextField
                    name="hkRateOverrideAmountFull"
                    margin="normal"
                    fullWidth
                    label="Monthly Rate Amount (HKD)"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    error={errors.hkRateOverrideAmountFull != null}
                    helperText={
                      errors.hkRateOverrideAmountFull != null
                        ? errors.hkRateOverrideAmountFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <TextField
                    name="hkRateOverrideLaundryFull"
                    margin="normal"
                    fullWidth
                    label="Laundry Credit"
                    variant="outlined"
                    inputRef={register}
                    type="number"
                    defaultValue={0}
                    onChange={(value) => {
                      onLaudryCreditChange(
                        value,
                        "hkRateOverride",
                        "Full Year"
                      );
                    }}
                    error={errors.hkRateOverrideLaundryFull != null}
                    helperText={
                      errors.hkRateOverrideLaundryFull != null
                        ? errors.hkRateOverrideLaundryFull.message
                        : null
                    }
                    disabled={auditResponse.loading}
                  />
                  <p>Gift 1 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkRateOverrideGift1Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift1Change(
                                  value,
                                  "hkRateOverride",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkRateOverrideGift1Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkRateOverrideGift1Full.message}
                        </div>
                      )}
                    </div>
                  )}
                  <p>Gift 2 (if any)</p>
                  {giftOptions.length > 0 && (
                    <div>
                      <Controller
                        name="hkRateOverrideGift2Full"
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.type
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isClearable={true}
                              options={giftOptions}
                              onChange={(value) => {
                                onGift2Change(
                                  value,
                                  "hkRateOverride",
                                  "Full Year"
                                );
                              }}
                              disabled={auditResponse.loading}
                            />
                          );
                        }}
                      />
                      {errors.hkRateOverrideGift2Full && (
                        <div style={{ marginLeft: 14, marginRight: 14, marginTop: 3, fontSize: "0.75rem", color: "#f44336" }}>
                          {errors.hkRateOverrideGift2Full.message}
                        </div>
                      )}
                    </div>
                  )}
                </FormPageCard>
            )}
            <FormPageCard>
                <FormActions>
                  <Button
                    type="submit"
                    size="large"
                    variant="contained"
                    color="primary"
                    disabled={auditResponse.loading}
                  >
                    Submit
                  </Button>
                </FormActions>
              </FormPageCard>
          </Stack>
        </form>
      </FormPageShell>
    );
  };

  return (
    !giftResponse.loading &&
    !roomTypeResponse.loading &&
    !propertyResponse.loading &&
    renderContent()
  );
};

export default NewPromotion;

/* {requirementsResponse.loading && !requirementsResponse.data && <Loader />}
      {!requirementsResponse.loading &&  */
